"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var text_1 = require("./text");
function DateDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/date.html',
        controller: /** @class */ (function (_super) {
            __extends(DateController, _super);
            function DateController($scope, book) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                _this.property = $scope.option.property;
                return _this;
            }
            DateController.prototype.onChange = function () {
                if (this.regexp && !this.regexp.test(this.form.value[this.property])) {
                    this.form.value = this.book.get(this.prefix, this.id);
                }
                else {
                    this.book.set(this.prefix, this.id, this.form.value);
                }
            };
            return DateController;
        }(text_1.TextController)),
        controllerAs: 'dateCtrl'
    };
}
exports.DateDirective = DateDirective;
